import React from 'react';
import { compose, withProps, lifecycle, withState, withHandlers } from 'recompose';
import { Grid as Grid2, Table, TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import { SortingState, IntegratedSorting } from '@devexpress/dx-react-grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import { get, find } from 'lodash';
import { getAttribute, updateAttribute } from '../attributes/_api';
import withLoader from '../app/withLoader';
import { Link } from 'react-router-dom';
import EditForm from './form/addForm';
import { withSnackbar } from 'notistack';
import { attributeLevel } from '../../utils/constants/';

const styles = (theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    padding: 20,
  },
});

const collator = new Intl.Collator('cs');

const comparePriority = (a, b) => {
  return collator.compare(a, b);
};

const enhance = compose(
  withStyles(styles),
  withSnackbar,
  withLoader,
  withProps(({ match: { params: { id } }, addAttribute }) => ({
    attributeId: id,
  })),
  withState('edit', 'setEdit', false),
  withState('attribute', 'setAttribute', null),
  withHandlers({
    loadItem: ({ toggleLoader, setAttribute, attributeId }) => async () => {
      toggleLoader();
      const resp = await getAttribute(attributeId);
      if (resp) {
        setAttribute(resp);
      }
      toggleLoader(false);
    },
  }),
  lifecycle({
    async componentDidMount() {
      const { loadItem } = this.props;
      loadItem();
    },
    async componentWillReceiveProps(nextProps) {
      const { loadItem } = this.props;
      if (this.props.reload !== nextProps.reload) {
        loadItem();
      }
    },
  }),

  withProps(({ setDialog }) => ({
    columns: [
      { name: 'type', title: 'Typ' },
      { name: 'value', title: 'Hodnota' },
      { name: 'unit', title: 'Jednotka' },
      {
        name: 'delete',
        title: ' ',
        getCellValue: (row) => (
          <div>
            <Button
              variant="outlined"
              onClick={(e) => {
                e.stopPropagation();
                setDialog({ open: true, id: row.id, action: 'attribute-value-delete' });
              }}
            >
              Smazat
            </Button>
          </div>
        ),
      },
    ],
  })),
  withHandlers({
    onSubmit: ({ attributeId, setEdit, loadItem, toggleLoader, enqueueSnackbar }) => async (
      values
    ) => {
      toggleLoader();
      const resp = await updateAttribute(attributeId, values);
      if (get(resp, 'success', false)) {
        enqueueSnackbar('Atributa byla úspěšně změněna.', { variant: 'success' });
        loadItem();
      } else {
        enqueueSnackbar('Atributu se nepodařilo změnit.', { variant: 'error' });
      }
      setEdit(false);
      toggleLoader(false);
    },
    redirectTo: ({ history, attributeId }) => (id) => {
      history.push(`/attributes/${attributeId}/values/${id}`);
    },
  }),
  withHandlers({
    TableRow: ({ redirectTo }) => ({ row, ...restProps }) => (
      <Table.Row
        {...restProps}
        style={{
          cursor: 'pointer',
          ':hover': { background: '#7eb6e4' },
        }}
        onClick={() => {
          redirectTo(get(row, 'id'));
        }}
      />
    ),
  })
);

export default enhance(
  ({ classes, attribute, values, attributeId, edit, setEdit, onSubmit, TableRow, columns }) => (
    <div className={classes.root}>
      <Grid container spacing={8}>
        {!edit && (
          <React.Fragment>
            <Grid item xs={12}>
              <b>Název atribut:</b> {get(attribute, 'name', '')}
            </Grid>
            <Grid item xs={12}>
              <b>Popis:</b> {get(attribute, 'description', '')}
            </Grid>
            <Grid item xs={12}>
              <b>Příslušnost:</b>{' '}
              {get(find(attributeLevel, { id: get(attribute, 'level', '') }), 'label')}
            </Grid>

            <Grid item xs={12} style={{ marginTop: 10 }}>
              <Button variant="contained" color="primary" onClick={() => setEdit(true)}>
                Upravit
              </Button>
            </Grid>
          </React.Fragment>
        )}
        {edit && (
          <EditForm
            setEdit={setEdit}
            linkBack={`/attributes/${attribute.id}`}
            initialValues={{
              name: attribute.name,
              description: attribute.description,
              level: attribute.level,
            }}
            onSubmit={onSubmit}
          />
        )}
        <Grid item xs={12} style={{ marginTop: 20 }}>
          <Button
            variant="contained"
            color="primary"
            component={(props) => <Link to={`/attributes/${attributeId}/add`} {...props} />}
          >
            Přidat hodnotu
          </Button>
          <Paper>
            <div className="grid--clickable grid--custom">
              <Grid2 rows={get(attribute, 'values', [])} columns={columns}>
                <SortingState defaultSorting={[{ columnName: 'value', direction: 'asc' }]} />
                <IntegratedSorting
                  columnExtensions={[{ columnName: 'value', compare: comparePriority }]}
                />
                <Table rowComponent={TableRow} />
                <TableHeaderRow showSortingControls />
              </Grid2>
            </div>
          </Paper>
        </Grid>
      </Grid>
    </div>
  )
);



// WEBPACK FOOTER //
// ./src/modules/attributes/detail.js